import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { select, Store } from '@ngxs/store';
import {
    PillCellComponent,
    PillHeaderCellComponent,
    PillHeaderRowComponent,
    HelpComponent,
    PillRowComponent,
    PillTableComponent
} from '@tran-monorepo/frontend/components';
import { ContentSectionComponent } from '../../../../shared/components/custom';
import { LoadMeetings } from '../../states/award-committee-meetings/award-committee-meetings.actions';
import { AwardCommitteeMeetingsState } from '../../states/award-committee-meetings/award-committee-meetings.state';
import { DatesAndDeadlinesSkeletonComponent } from './dates-and-deadlines-skeleton.component';

@Component({
    selector: 'tran-customer-home-dates-and-deadlines-table',
    imports: [
        DatePipe,
        ContentSectionComponent,
        TranslatePipe,
        PillTableComponent,
        PillCellComponent,
        PillRowComponent,
        PillHeaderRowComponent,
        PillHeaderCellComponent,
        HelpComponent,
        DatesAndDeadlinesSkeletonComponent
    ],
    templateUrl: './dates-and-deadlines-table.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatesAndDeadlinesTableComponent implements OnInit {
    private readonly store = inject(Store);

    protected readonly loading = select(AwardCommitteeMeetingsState.loading);
    protected readonly meetings = select(AwardCommitteeMeetingsState.meetings);

    protected readonly headers: { title: string; helpTitle?: string; helpText?: string }[] = [
        {
            title: 'home.dates-and-deadlines.headers.submit-deadline.title',
            helpTitle: 'home.dates-and-deadlines.headers.submit-deadline.help-title',
            helpText: 'home.dates-and-deadlines.headers.submit-deadline.help-text'
        },
        {
            title: 'home.dates-and-deadlines.headers.pre-award-deadline.title',
            helpTitle: 'home.dates-and-deadlines.headers.pre-award-deadline.help-title',
            helpText: 'home.dates-and-deadlines.headers.pre-award-deadline.help-text'
        },
        {
            title: 'home.dates-and-deadlines.headers.award-end-date.title',
            helpTitle: 'home.dates-and-deadlines.headers.award-end-date.help-title',
            helpText: 'home.dates-and-deadlines.headers.award-end-date.help-text'
        }
    ];

    ngOnInit(): void {
        this.store.dispatch(new LoadMeetings());
    }
}
